import {
    Component,
    OnDestroy,
    Input
} from '@angular/core';
import { eAccountType, eCampaignStatus, eCreativeStatusBuild } from '@Workspace/_generated/enums';
import { ICreativeAssetDto } from '@Workspace/_generated/interfaces';
import { Constants } from '@Workspace/common';



@Component({
    selector: 'file-approve',
    templateUrl: './file-approve.component.html',
    styleUrls: ['./file-approve.component.scss']
})
export class FileApproveComponent implements OnDestroy {

    enumCampaignStatus = eCampaignStatus;
    enumCreativeStatusBuild = eCreativeStatusBuild;
    @Input() creativeAsset: ICreativeAssetDto;
    @Input() isApprovedReported: boolean;
    @Input() reviewPage: boolean;
    @Input() isFromPreview: boolean;
    @Input() headerTitle: string;
    @Input() statusId: eCampaignStatus;
    @Input() campaignStatusId: eCampaignStatus;
    @Input() campaignType: eAccountType;
    @Input() creativeStatusBuildId: eCreativeStatusBuild;
    approveReport(event) {
        this.creativeAsset.isValid = event;
        this.isApprovedReported = true;

    }

    canChangeApproveStatus(): boolean {
        const isHS = this.campaignType === eAccountType.HS;
        const isApproved = this.campaignStatusId === eCampaignStatus.Assets_Approved || this.statusId === eCampaignStatus.Assets_Approved;
        const hasValidFile = !!this.creativeAsset.file && this.creativeAsset.fileId !== Constants.GuidEmpty;
    
        if (!isHS) return true;
        if (!isApproved) return true;
    
        return hasValidFile;
    }

    // New method to check if the asset can be edited
    canEditAsset(): boolean {
        return (
            this.creativeStatusBuildId === eCreativeStatusBuild.Send_to_API &&
            this.campaignType !== eAccountType.HS
        );
    }


    ngOnDestroy(): void {

    }

}